import { queryClient } from "@/config/react-query";

import type { PatientSidebarCounts } from "@/types/patient-sidebar";

import { patientQueryKeys } from "./patient-query";

export function optimisticAdjustSidebarCounts(
  patientId: string,
  deltaByKey: Partial<Record<keyof PatientSidebarCounts, number>>,
): PatientSidebarCounts | undefined {
  const key = patientQueryKeys.sidebarCounts(patientId);
  const previous = queryClient.getQueryData<PatientSidebarCounts | undefined>(
    key,
  );
  if (!previous) return;
  const next: PatientSidebarCounts = { ...previous };
  (Object.keys(deltaByKey) as Array<keyof PatientSidebarCounts>).forEach(
    (key) => {
      const delta = deltaByKey[key];
      if (typeof delta === "number") {
        const current = next[key] ?? 0;
        // never go below zero
        next[key] = Math.max(0, current + delta);
      }
    },
  );
  queryClient.setQueryData(key, next);
  return previous;
}

export function revertSidebarCounts(
  patientId: string,
  previous: PatientSidebarCounts | undefined,
) {
  if (!previous) return;
  queryClient.setQueryData(patientQueryKeys.sidebarCounts(patientId), previous);
}

export function invalidateSidebarCounts(patientId: string) {
  queryClient.invalidateQueries({
    queryKey: patientQueryKeys.sidebarCountsForPatient(patientId),
  });
}
